import keyMirror from "key-mirror";

export const XHR_ERRORS = keyMirror({
    NETWORK_ERROR: null,
    INVALID_CREDENTIALS: null,
    HTTP_400_BAD_REQUEST: null,
    SERVICE_DOWN: null,
    HTTP_404_NOT_FOUND: null
});
